module.exports = __webpack_public_path__ + "img/ch21_02_撤离之夜.48d81160.jpg";